module.exports = __webpack_public_path__ + "static/Muayyad-Adili-d136c416e3b93ce7d9554ef460015c69.webp";